import React, { useEffect, useRef, useState } from 'react';

import {
  Button,
  IconSpinner,
  LayoutComposer,
  LayoutSingleColumn,
  Page,
} from '../../components/index.js';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer.js';
import FooterContainer from '../FooterContainer/FooterContainer.js';
import css from './faq.module.css';
import image1 from '../../assets/path_to_colorful_fabric_image.jpg';
import image2 from '../../assets/path_to_office_image.jpg';

import forShoppersImage from '../../assets/New Images/FAQ-Shoppers.jpg'
import forSellersImage from '../../assets/New Images/FAQ-Sellers.jpg'
import image3 from '../../assets/1.jpg';
import CollapsibleSection from './CollapsibleSection';
import PhotoTips from './PhotoTips.js';
import { FormattedMessage } from 'react-intl';
import ConditionDescription from './ConditionDescription.js';
import FlatRateBoxTable from './FlatRateBoxTable.js';
import { useLocation } from 'react-router-dom';
const Faq = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState('sellers');
  const listingRef = useRef(null);
  const photoTipsRef = useRef(null);
  const conditionRef = useRef(null);
  const cancelRef = useRef(null);
  const allIsWellRef = useRef(null);
  const shippingBoxRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isClient, setIsClient] = useState(false);

  const [showGoBackAlert, setShowGoBackAlert] = useState(false);
  useEffect(() => {
    if (location && location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has('goback')) {
        setShowGoBackAlert(true);
      } else {
        setShowGoBackAlert(false);
      }
    }
  }, [location]);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Set client-side flag
  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    // Prevent SSR issues
    if (!isClient || !location) return;

    try {
      if (location.hash) {
        setSelectedTab('sellers');
        if (location.hash === '#cancel' || location.hash === '#allIsWell') {
          setSelectedTab('shoppers');
        }
        const targetRef =
          location.hash === '#listing'
            ? listingRef
            : location.hash === '#photoTips'
            ? photoTipsRef
            : location.hash === '#condition'
            ? conditionRef
            : location.hash === '#cancel'
            ? cancelRef
            : location.hash === '#allIsWell'
            ? allIsWellRef
            : location.hash === '#shippingBox'
            ? shippingBoxRef
            : null;

        if (targetRef?.current) {
          requestAnimationFrame(() => {
            const yOffset = -100;
            const element = targetRef.current;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({ top: y, behavior: 'smooth' });

            const collapsible = element.querySelector('.Collapsible__trigger');
            if (collapsible) {
              collapsible.click();
            }
          });
        }
      }
    } catch (error) {
      console.error('Error handling FAQ navigation:', error);
    }
  }, [location, listingRef, photoTipsRef, conditionRef, cancelRef, isClient, allIsWellRef, shippingBoxRef]);

  const handleTabClick = tab => {
    if (tab === selectedTab) return;
    setIsTransitioning(true);

    setSelectedTab(tab);
    setIsTransitioning(false);
  };
  return (
    <Page title="FAQs">
      <LayoutSingleColumn
        mainColumnClassName={css.layoutWrapperMain}
        topbar={<TopbarContainer className={css.topbar} currentPage={'FAQs'} />}
        footer={<FooterContainer />}
      >
        {showGoBackAlert && (
          <div className={css.goBackAlert}>
            <FormattedMessage id="faq.goBackAlert"/>
          </div>
        )}
        <div className={showGoBackAlert ? css.faqContentWithAlert : undefined}>
          <div className={css.container}>
            <div className={css.imageContainer}>
              <img
                src={image1}
                alt="colorful fabric"
                className={css.imageHeader}
                onLoad={() => setIsLoaded(true)}
              />
              {!isLoaded && <div style={{ width: '100%', height: '600px' }}></div>}
              <div className={css.textContainer}>
                <h1 className={css.heading}>
                  <FormattedMessage id="faq.MainFaqTitle" />
                </h1>
                <div className={css.buttonContainer}>
                  <Button
                    className={css.button}
                    style={
                      selectedTab === 'sellers' ? { backgroundColor: '#f2684b', color: 'white' } : {}
                    }
                    onClick={() => handleTabClick('sellers')}
                  >
                    <FormattedMessage id="faq.ForSellersTitle" />
                  </Button>
                  <Button
                    className={css.button}
                    style={
                      selectedTab === 'shoppers' ? { backgroundColor: '#f2684b', color: 'white' } : {}
                    }
                    onClick={() => handleTabClick('shoppers')}
                  >
                    <FormattedMessage id="faq.ForShoppersTitle" />
                  </Button>
                </div>
              </div>
            </div>
            <div className={isTransitioning ? css.tabContentHidden : css.tabContentt}>
              {/* <div className={css.imageContainer}>
                <img
                  src={forSellersImage}
                  alt="colorful office"
                  className={`${css.image} ${
                    selectedTab === 'sellers' ? css.imageVisible : css.imageHidden
                  }`}
                />

                <img
                  src={forShoppersImage}
                  alt="three ladies"
                  className={`${css.image} ${
                    selectedTab === 'shoppers' ? css.imageVisible : css.imageHidden
                  }`}
                />
                {!isLoaded && <div style={{ width: '100%', height: '470px' }}></div>}
                <div className={css.textContainerOffice}>
                  <h2>
                    <FormattedMessage id="faq.MainFaqTitle" />
                  </h2>
                  <div className={css.buttonContainer}>
                    {selectedTab === 'sellers' ? (
                      <h1 className={css.heading}>
                        <FormattedMessage id="faq.ForSellersTitle" />
                      </h1>
                    ) : (
                      <h1 className={css.heading}>
                        <FormattedMessage id="faq.ForShoppersTitle" />
                      </h1>
                    )}
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className={isTransitioning ? css.tabContentHidden : css.tabContent}>
            {selectedTab === 'sellers' ? (
              <>
                <div id="sellerSection" className={css.collapsibleContainer1}>
                <div className={css.titleNew}>
                  <FormattedMessage id="faq.seller.title" />
                </div>
                  <div className={css.title}>
                    <FormattedMessage id="faq.condition.title" />
                  </div>
                  <CollapsibleSection
                    id="condition"
                    title={<FormattedMessage id="faq.condition.whatKindOfItems.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.condition.whatKindOfItems.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    ref={conditionRef}
                    title={<FormattedMessage id="faq.condition.describeCondition.title" />}
                  >
                    <ConditionDescription />
                  </CollapsibleSection>
                  <CollapsibleSection title={<FormattedMessage id="faq.condition.cleanItem.title" />}>
                    <p>
                      <FormattedMessage id="faq.condition.cleanItem.content" />
                    </p>
                  </CollapsibleSection>
                </div>

                <div className={css.collapsibleContainer}>
                  <div className={css.title}>
                    <FormattedMessage id="faq.pricing.title" />
                  </div>
                  <CollapsibleSection title={<FormattedMessage id="faq.pricing.listingCost.title" />}>
                    <p>
                      <FormattedMessage id="faq.pricing.listingCost.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection title={<FormattedMessage id="faq.pricing.sellingFees.title" />}>
                    <p>
                      <FormattedMessage id="faq.pricing.sellingFees.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    title={<FormattedMessage id="faq.pricing.negotiatePricing.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.pricing.negotiatePricing.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    title={<FormattedMessage id="faq.pricing.whyWeUseStripe.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.pricing.whyWeUseStripe.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    title={<FormattedMessage id="faq.pricing.bankingInfoComfort.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.pricing.bankingInfoComfort.content" />
                    </p>
                  </CollapsibleSection>
                  {/* id is not on the lisiting div because it was going a bit down then required */}
                  <CollapsibleSection
                    id="listing"
                    title={<FormattedMessage id="faq.pricing.payment.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.pricing.payment.content" />
                    </p>
                  </CollapsibleSection>
                </div>

                <div className={css.collapsibleContainer1}>
                  <div className={css.title}>
                    <FormattedMessage id="faq.listing.title" />
                  </div>
                  <CollapsibleSection title={<FormattedMessage id="faq.listing.howToList.title" />}>
                    <p>
                      <FormattedMessage id="faq.listing.howToList.content" values={{ br: <br /> }} />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    id="photoTips"
                    title={<FormattedMessage id="faq.listing.chooseSection.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.listing.chooseSection.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    title={<FormattedMessage id="faq.listing.describeAndPrice.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.listing.describeAndPrice.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    ref={photoTipsRef}
                    title={<FormattedMessage id="faq.listing.photoTips.title" />}
                  >
                    <PhotoTips />
                  </CollapsibleSection>
                  <CollapsibleSection
                    ref={shippingBoxRef}
                    id="shippingBox"
                    title={<FormattedMessage id="faq.listing.shippingBox.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.listing.shippingBox.content" />
                    </p>
                  </CollapsibleSection>
                </div>

                <div className={css.collapsibleContainer}>
                  <div className={css.title}>
                    <FormattedMessage id="faq.postSale.title" />
                  </div>
                  <CollapsibleSection
                    title={<FormattedMessage id="faq.postSale.buyerSelectsItem.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.postSale.buyerSelectsItem.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    title={<FormattedMessage id="faq.postSale.shippingPhotos.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.postSale.shippingPhotos.content" />
                    </p>
                  </CollapsibleSection>
                  <CollapsibleSection
                    // title={<FormattedMessage id="faq.postSale.packageSize.title" />}
                    title={<FormattedMessage id="faq.postSale.packageSize.titleNew" />}
                  >
                    <FlatRateBoxTable />
                  </CollapsibleSection>
                  <CollapsibleSection
                    title={<FormattedMessage id="faq.postSale.additionalSteps.title" />}
                  >
                    <p>
                      <FormattedMessage id="faq.postSale.additionalSteps.content" />
                    </p>
                  </CollapsibleSection>
                </div>
              </>
            ) : null}

            {selectedTab === 'shoppers' ? (
              <div id="buyerSection" className={css.collapsibleContainer1}>
                <div className={css.title}>
                  <FormattedMessage id="faq.buyers.title" />
                </div>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.messageSeller.title" />}>
                  <p>
                    <FormattedMessage id="faq.buyers.messageSeller.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.negotiatePrice.title" />}>
                  <p>
                    <FormattedMessage id="faq.buyers.negotiatePrice.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.purchaseItem.title" />}>
                  <p>
                    <FormattedMessage id="faq.buyers.purchaseItem.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.paymentForms.title" />}>
                  <p>
                    <FormattedMessage id="faq.buyers.paymentForms.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.additionalFees.title" />}>
                  <p>
                    <FormattedMessage
                      id="faq.buyers.additionalFees.content"
                      values={{
                        link: (
                          <a
                            href="https://www.options.bc.ca/program/healthiest-babies-possible"
                            target="_blank"
                          >
                            here
                          </a>
                        ),
                      }}
                    />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.shippingCosts.title" />}>
                  <p>
                    <FormattedMessage
                      id="faq.buyers.shippingCosts.content"
                      values={{
                        link: (
                          <a
                            href="https://www.canadapost-postescanada.ca/cpc/en/personal/stamps-and-packaging/flat-rate-box.page"
                            target="_blank"
                          >
                            here
                          </a>
                        ),
                      }}
                    />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.whyWeUseStripe.title" />}>
                  <p>
                    <FormattedMessage
                      id="faq.buyers.whyWeUseStripe.content"
                      values={{
                        link: (
                          <a
                            href="https://www.canadapost-postescanada.ca/cpc/en/personal/stamps-and-packaging/flat-rate-box.page"
                            target="_blank"
                          >
                            here
                          </a>
                        ),
                      }}
                    />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.buyNowButton.title" />}>
                  <p>
                    <FormattedMessage id="faq.buyers.buyNowButton.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection title={<FormattedMessage id="faq.buyers.sellerMailTime.title" />}>
                  <p>
                    <FormattedMessage id="faq.buyers.sellerMailTime.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection
                  id="cancel"
                  title={<FormattedMessage id="faq.buyers.shippingNotification.title" />}
                >
                  <p>
                    <FormattedMessage id="faq.buyers.shippingNotification.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection
                  // ref={cancelRef}
                  title={<FormattedMessage id="faq.buyers.cancelOrder.title" />}
                >
                  <p>
                    <FormattedMessage id="faq.buyers.cancelOrder.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection
                  id="allIsWell"
                  title={<FormattedMessage id="faq.buyers.returnItem.title" />}
                >
                  <p>
                    <FormattedMessage id="faq.buyers.returnItem.content" />
                  </p>
                </CollapsibleSection>
                <CollapsibleSection
                  ref={allIsWellRef}
                  title={<FormattedMessage id="faq.buyers.receiveItem.title" />}
                >
                  <p>
                    <FormattedMessage id="faq.buyers.receiveItem.content" />
                  </p>
                </CollapsibleSection>
              </div>
            ) : null}
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default Faq;
